/* ═══════════════════════════════════════════════════════════════════
   APTUX WAY — Accordion web component
   Used by ingredients (collapsible "fórmula completa") and FAQ blocks.

   Usage:
     <aptux-accordion>
       <button class="aw-accordion-trigger" aria-expanded="false">
         Ver fórmula completa
       </button>
       <div class="aw-accordion-panel" hidden>
         <!-- collapsible content -->
       </div>
     </aptux-accordion>

   For multi-item FAQs:
     <aptux-accordion data-multi="single">
       <div class="aw-accordion-item">
         <button class="aw-accordion-trigger">...</button>
         <div class="aw-accordion-panel" hidden>...</div>
       </div>
       <!-- more items -->
     </aptux-accordion>
   ═══════════════════════════════════════════════════════════════════ */

class AptuxAccordion extends HTMLElement {
  connectedCallback() {
    // Mode: 'multi' (FAQ-style, multiple panels can be open)
    // or 'single' (only one panel open at a time)
    // or default (single trigger/panel, simple toggle)
    this.mode = this.dataset.multi || 'simple';

    const triggers = this.querySelectorAll('.aw-accordion-trigger');
    triggers.forEach((trigger) => {
      const panel = trigger.nextElementSibling;
      if (!panel || !panel.classList.contains('aw-accordion-panel')) return;

      // Set initial ARIA state
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      panel.hidden = !isOpen;

      trigger.addEventListener('click', () => this.toggle(trigger, panel, triggers));
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggle(trigger, panel, triggers);
        }
      });
    });
  }

  toggle(trigger, panel, allTriggers) {
    const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
    const willOpen = !wasOpen;

    // In 'single' mode, close all others first
    if (this.mode === 'single' && willOpen) {
      allTriggers.forEach((t) => {
        if (t !== trigger) {
          t.setAttribute('aria-expanded', 'false');
          const p = t.nextElementSibling;
          if (p && p.classList.contains('aw-accordion-panel')) p.hidden = true;
        }
      });
    }

    trigger.setAttribute('aria-expanded', String(willOpen));
    panel.hidden = !willOpen;
  }
}

if (!customElements.get('aptux-accordion')) {
  customElements.define('aptux-accordion', AptuxAccordion);
}
